<button class="close" (click)="close()" [ngStyle]="{'top': top, 'bottom': bottom, 'right': right, 'left': left}" mat-icon-button>
  <i class="material-icons">close</i>
</button>